import React from 'react';
import PropTypes from 'prop-types';

function UMOView({ params }, context) {
  return (
    <div className="umo-view">
      <button onClick={() => context.router.push('/home')}>Home</button>
      umo view {params.umoID}
    </div>
  );
}

UMOView.contextTypes = {
  router: PropTypes.object,
};

UMOView.propTypes = {
  params: PropTypes.shape({
    umoID: PropTypes.string,
  }).isRequired,
};

export default UMOView;



// WEBPACK FOOTER //
// ./src/js/components/UMOView/index.jsx